/**
 * BRIDGE SERP split — authority-side URLs moved to umojareg.org.
 * These rules are consumed by App.tsx renderRedirects() and produce
 * cross-origin <ExternalRedirect> routes (vs. internal <Navigate>).
 *
 * Fallback host: https://rnec-ethical-gate.lovable.app (use until umojareg.org
 * DNS is fully cut over). To switch, replace UMOJAREG_HOST below.
 */

export const UMOJAREG_HOST = "https://umojareg.org";

export interface ExternalRedirectRule {
  from: string;          // exact path on pharmatrialconnect.com
  toPath: string;        // path on UmojaReg, prefixed with /
  // For prefix-style redirects (e.g. /serp/*) put the literal "*" at the end
  // of `from`. The router will pass through the remainder.
  prefix?: boolean;
}

export const umojaregRedirects: ExternalRedirectRule[] = [
  // Authority-side one-pagers moved per audit
  { from: "/resources/regulatory-fragmentation",         toPath: "/resources/regulatory-fragmentation" },
  { from: "/resources/ethics-track",                     toPath: "/resources/ethics-track" },
  { from: "/resources/twinnet-sovereign",                toPath: "/resources/twinnet-sovereign" },
  { from: "/resources/edctp3-ra-hub",                    toPath: "/resources/edctp3-ra-hub" },
  { from: "/resources/edctp3-consortium-rollup",         toPath: "/resources/edctp3-consortium-rollup" },
  { from: "/resources/tot-lms",                          toPath: "/resources/tot-lms" },

  // Authority module shells (prefix matches handled in App.tsx)
  { from: "/serp/*",     toPath: "/serp/",     prefix: true },
  { from: "/twinnet/*",  toPath: "/twinnet/",  prefix: true },
  { from: "/avaref/*",   toPath: "/avaref/",   prefix: true },

  // Regulator-facing ToT (CHW/site ToT stays on PTC under /trial-site/tot/*)
  { from: "/tot/regulator/*",          toPath: "/umoja/tot/",                  prefix: true },
  { from: "/ethics-track/regulator/*", toPath: "/umoja/tot/ethics-advanced/",  prefix: true },

  // WHO GBT country-rating platform — full handoff (live tracker + public dashboard)
  { from: "/serp/ra/gbt",              toPath: "/umoja/gbt/tracker" },
  { from: "/serp/ra/gbt-maturity",     toPath: "/umoja/gbt/tracker" },
  { from: "/resources/who-gbt-dashboard", toPath: "/umoja/gbt/dashboard" },
  { from: "/gov/who-gbt-dashboard",    toPath: "/umoja/gbt/dashboard" },
];

export function buildUmojaregUrl(rule: ExternalRedirectRule, remainder = ""): string {
  return `${UMOJAREG_HOST}${rule.toPath}${remainder}`;
}
